import BroadcastContainer from './BroadcastContainer';

export default BroadcastContainer;
